module.exports = __webpack_public_path__ + "static/patagonia_737x514-f60f37decf37ca111c79289365b13aad.png";